module.exports = __webpack_public_path__ + "img/speaker_16.45e398be.jpg";